/**
 * Breakpoints Design Tokens
 *
 * ⭐ MODIFY BREAKPOINTS HERE
 * Change these values to update responsive breakpoints
 */

export const breakpoints = {
  sm: '640px',    // Mobile landscape, small tablets
  md: '768px',    // Tablets
  lg: '1024px',   // Laptop
  xl: '1280px',   // Desktop
  '2xl': '1536px', // Large desktop
} as const;

// Product grid columns per breakpoint
export const gridColumns = {
  base: 1,   // Mobile
  sm: 2,     // Tablet
  lg: 3,     // Laptop
  xl: 4,     // Desktop
} as const;
